export class WorkflowEditorActionConstants {
    static readonly DENIED_RETURN_TO_CAM = 'deniedReturnToCAM';
    static readonly DENIED_SEND_TO_AAP = 'deniedSendToAAP';

    static readonly REVERSE_OR_DELETE_RETURN_TO_CAM = 'reverseDeniedReturnToCAM';
    static readonly REVERSE_OR_DELETE_SEND_TO_AAP = 'reverseDeniedSendToAAP';
    static readonly COMPLETE_WORKFLOW = 'completeWorkflow';

    static readonly REVERSE_ACTION = 'reverse';
    static readonly DELETE_ACTION = 'delete';
}
